import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import firebase from "firebase";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addLink } from "../../../../../store/actions/actions";

const AddLinkModal = ({
  show,
  onClose,
  title = "Add URL",
  confirmText = "Save",
  project_id,
  section_id,
}) => {
  const [url, setUrl] = useState("");

  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedUrl = url.trim();

    const isValidUrl = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i.test(trimmedUrl);
    if (!isValidUrl) {
      toast.error("Please enter a valid URL.");
      return;
    }

    try {
      const linksCollectionRef = firebase
        .firestore()
        .collection("projects")
        .doc(project_id)
        .collection("section")
        .doc(section_id)
        .collection("links");

      const newLinkDoc = linksCollectionRef.doc();
      const linkData = {
        url: url.trim(),
        project_id,
        section_id,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      await newLinkDoc.set(linkData);

      const addedData = { id: newLinkDoc.id, ...linkData };

      console.log({ addedData });

      dispatch(addLink(addedData));
      toast.success("Link added successfully!");

      setUrl("");
      onClose();
    } catch (error) {
      console.error("Error saving link:", error);
      toast.error("Error adding link.");
    }
  };

  return (
    <Modal centered show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>{title}</Modal.Title>
          <p className="mb-0 small text-muted">
            Fields marked (<span className="text-danger">*</span>) are
            mandatory.
          </p>
        </div>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label className="small text-uppercase font-weight-bold text-muted">
              URL <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter a valid URL"
              autoComplete="off"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              required
            />
          </Form.Group>

          <div className="text-right">
            <Button variant="secondary" onClick={onClose} className="mr-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              {confirmText}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddLinkModal;
